export default __webpack_public_path__ + "static/hirmd_logo.51b83cba6fd02feaafe1cd4b34b35a19.jpg";